import { PARAMS } from "~/constants/request";

export const getQueryFromUrl = (url: string): { [key in PARAMS]?: string } => {
  const params = url?.split("?")[1];
  const urlParams = new URLSearchParams(params);

  return Object.fromEntries(urlParams) ?? {};
};
